export default __webpack_public_path__ + "static/media/Lounge.817c861e.jpg";